import { render } from "./Sankey.vue?vue&type=template&id=6a6dfd2a"
import script from "./Sankey.vue?vue&type=script&lang=js"
export * from "./Sankey.vue?vue&type=script&lang=js"

import "./Sankey.vue?vue&type=style&index=0&id=6a6dfd2a&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__